import { FC, useMemo } from "react";
import { Box } from "@mui/material";
import GraphMap from "../../../../../components/charts/GraphMap";
import { TransportArc, TransportNode } from "../../../../../datasources/carbonsnap/models";
import { calcMapConfig } from "../../../../../components/charts/GraphMap/utils";
import CarbonSnapLayer from "./CarbonSnapLayer";
import "leaflet/dist/leaflet.css";

interface Props {
	nodes: TransportNode[];
	arcs: TransportArc[];
}

const DEFAULT_CENTER: [number, number] = [41.9028, 12.4964]; // Rome coordinates

const CarbonSnapMap: FC<Props> = ({ nodes, arcs }) => {
	const mapConfig = useMemo(() => {
		const validPoints = nodes
			.filter((n) => n.lat !== null && n.lng !== null)
			.map((n) => ({ lat: n.lat!, lng: n.lng! }));

		if (validPoints.length === 0) {
			return {
				center: DEFAULT_CENTER,
				zoom: 6,
			};
		}

		return calcMapConfig(validPoints);
	}, [nodes]);

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				borderRadius: 2,
				overflow: "hidden",
			}}
		>
			<GraphMap
				tileProvider="heremaps"
				center={mapConfig.center}
				zoom={mapConfig.zoom}
				minZoom={3}
				maxZoom={18}
				height="100%"
			>
				<CarbonSnapLayer nodes={nodes} arcs={arcs} />
			</GraphMap>
		</Box>
	);
};

export default CarbonSnapMap;
